import { render, staticRenderFns } from "./DataSourceAdd.vue?vue&type=template&id=54114f92&"
import script from "./DataSourceAdd.vue?vue&type=script&lang=js&"
export * from "./DataSourceAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports